import { Options } from 'ky';
import config from 'config';
import { downloadFile } from 'utils/api';
import { getPrefixUrl, ModuleNames } from 'utils/apiClient/url';
import {
  TARExportPayload,
  TSSDevicesPayload,
  TARExport,
  FiscalizationCheckResponse,
  ClientDataList,
  AccountData,
} from './types';
import { useAuthenticatedApiClient } from '../../base';

const ksvClientOpts: Options = {
  prefixUrl: getPrefixUrl(ModuleNames.KSV),
};

const customJsonHeader = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

/* eslint-disable import/prefer-default-export */
export const useKsvApi = () => {
  const authenticatedApiClient = useAuthenticatedApiClient();
  const ksvClient = authenticatedApiClient.extend(ksvClientOpts);
  return {
    // ksv
    activateKsv: () =>
      authenticatedApiClient.post(`${config.CORE_URL}/api/tss/buy/`, {
        headers: customJsonHeader,
        body: null,
      }),
    getKsvStatus: (accId: number) =>
      ksvClient.get(`accounts/${accId}/fiscalization_check/`).json(),
    // devices
    getTSEDevices: (accountId: string) =>
      ksvClient
        .get(`accounts/${accountId}/?show_disabled=true`)
        .json<TSSDevicesPayload>(),
    getDeviceDetails: (payload: string) =>
      ksvClient.get(`devices/${payload}/details/`).json(),
    getKsvProvisioningStatus: () =>
      ksvClient
        .get(`accounts/me/fiscalization_check/`)
        .json<FiscalizationCheckResponse>(),
    // exports
    saveExportTSS: (payload: TARExportPayload) =>
      ksvClient.post('export/', {
        headers: customJsonHeader,
        body: JSON.stringify(payload),
      }),
    downloadExport: async (export_id: string) => {
      const response = await ksvClient.get(`export/${export_id}/fetch/`, {
        headers: customJsonHeader,
        timeout: 200000,
      });
      const file = await response.blob();
      downloadFile(file, `ksv-${export_id}`, 'tar');
    },
    getExports: () =>
      ksvClient
        .get(`export/`, {
          headers: customJsonHeader,
        })
        .json<Array<TARExport>>(),

    getClientDataList: async () =>
      ksvClient.get(`client-data/`).json<ClientDataList>(),

    getAccountData: async (accountId: string) =>
      ksvClient.get(`accounts/${accountId}/`).json<AccountData>(),
  };
};
